<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Roles</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]"><i class="ti ti-smart-home"></i></a>
          </li>
          <!-- <li class="breadcrumb-item">Administration</li> -->
          <li class="breadcrumb-item active" aria-current="page">Roles</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="me-2 mb-2 d-none">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-2 me-2">
        <a
          *appHasPermission="{ role: ['add'] }"
          href="javascript:void(0);"
          class="btn btn-primary d-flex align-items-center"
          (click)="openBusinessModal(addBusinessModals, '', 'Create Role')"
          ><i class="ti ti-circle-plus me-2"></i>Create Role</a
        >
      </div>
      <!-- <div class="mb-2">
        <a
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#add_role"
          class="btn btn-primary d-flex align-items-center"
          (click)="openBusinessModal(addBusinessModals, '', 'Create Permission Sets')"
          ><i class="ti ti-circle-plus me-2"></i>Create Permission Sets</a
        >
      </div> -->
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <!-- Assets Lists -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Roles</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>
        <!-- <div class="dropdown me-3">
          <select class="form-select" #roletypeSelect [(ngModel)]="roletype" (change)="loadRoles()">
            <option value="" selected>Select Type</option>
            <option value="Role">Role</option>
            <option value="Permission Sets">Permission Sets</option>
          </select>
        </div> -->

        <div class="dropdown me-3">
          <select
            class="form-select"
            #standardSelect
            [(ngModel)]="isStandard"
            (change)="onIsStandardChange()"
          >
            <option value="" selected>Is Standard?</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        <div class="me-3 d-none">
          <div class="input-icon-end position-relative">
            <input
              type="text"
              id="daterange"
              name="daterange"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
            />
            <span class="input-icon-addon">
              <i class="ti ti-chevron-down"></i>
            </span>
          </div>
        </div>
        <!-- <div class="dropdown me-3">
          <select
            class="form-select"
            #businessSelect
            [(ngModel)]="businessId"
            (change)="loadRoles()"
          >
            <option value="" selected>Select Business Entity</option>
            <option *ngFor="let business of businesses$ | async" [value]="business.id">
              {{ business.businessName | capitalize }}
            </option>
          </select>
        </div> -->
        <ng-select
          class="me-3"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="businessId"
          (change)="onIsStandardChange()"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>
        <div class="dropdown me-3">
          <select class="form-select" #statusSelect [(ngModel)]="status" (change)="loadRoles()">
            <option value="" selected>Select Status</option>
            <option value="false">Active</option>
            <option value="true">Inactive</option>
          </select>
        </div>
        <div class="form-sort search-box">
          <label>
            <input
              type="search"
              [(ngModel)]="search"
              class="form-control"
              placeholder="Search"
              (input)="onSearch()"
          /></label>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <ng-container *ngIf="roles$ | async as roles">
          <table class="table datatable" *ngIf="roles.length > 0; else noRecords">
            <thead class="thead-light">
              <tr>
                <th>Role</th>
                <th>Business Entity</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let role of roles$ | async">
                <ng-container *ngIf="role.name !== 'Contractor'; else contractorRow">
                  <ng-container
                    *ngTemplateOutlet="roleRow; context: { $implicit: role }"
                  ></ng-container>
                </ng-container>
                <ng-template #contractorRow>
                  <ng-container *appHasModule="'contractor'">
                    <ng-container
                      *ngTemplateOutlet="roleRow; context: { $implicit: role }"
                    ></ng-container>
                  </ng-container>
                </ng-template>
              </ng-container>
              <!-- <tr *ngFor="let role of roles$ | async"> -->
              <ng-template #roleRow let-role>
                <tr>
                  <td>{{ role.name }}</td>

                  <td>{{ role.business ? role.business.businessName : 'AVR HRMS' }}</td>

                  <td>
                    <span
                      *ngIf="!role.disabled"
                      class="badge badge-success d-inline-flex align-items-center badge-xs"
                    >
                      Active
                    </span>
                    <span
                      *ngIf="role.disabled"
                      class="badge badge-danger d-inline-flex align-items-center badge-xs"
                    >
                      Inactive
                    </span>
                  </td>
                  <td>
                    <div class="action-icon d-inline-flex">
                      <a [routerLink]="[eps.role.roledetailsPath, role.id]" class="me-2"
                        ><i class="ti ti-eye"></i
                      ></a>
                      <ng-container
                        *ngIf="
                          isAdmin() &&
                          ['Admin', 'Business Owner', 'Employee', 'Contractor', 'Trainee'].includes(
                            role.name
                          )
                        "
                      >
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          *appHasPermission="{ role: ['edit'] }"
                          (click)="
                            openBusinessModal(addBusinessModals, role, 'Edit Role: ' + role.name)
                          "
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                      </ng-container>
                      <!-- <ng-container
                      *ngIf="
                        !role.isStandard &&
                        role.name !== 'Admin' &&
                        role.name !== 'Business Owner' &&
                        role.name !== 'Employee' &&
                        role.name !== 'Contractor' &&
                        role.name !== 'Trainee'
                      "
                    > -->
                      <ng-container
                        *ngIf="
                          role.name !== 'Admin' &&
                          role.name !== 'Business Owner' &&
                          role.name !== 'Employee' &&
                          role.name !== 'Contractor' &&
                          role.name !== 'Trainee'
                        "
                      >
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          *appHasPermission="{ role: ['edit'] }"
                          (click)="openBusinessModal(addBusinessModals, role, '')"
                        >
                          <i class="ti ti-edit"></i>
                        </a>
                      </ng-container>

                      <!-- <a
                        href="javascript:void(0);"
                        class="me-2"
                        (click)="
                          openBusinessModal(viewBusinessModals, role, 'View Role: ' + role.name)
                        "
                        ><i class="ti ti-info-circle text-info"></i
                      ></a> -->
                      <a
                        href="javascript:void(0);"
                        class="me-2"
                        (click)="
                          openBusinessModal(viewBusinessModals, role, 'View Role: ' + role.name)
                        "
                        ><i class="ti ti-info-circle text-info"></i
                      ></a>

                      <!-- <a
                      href="javascript:void(0);"
                      class="me-2"
                      *ngIf="
                        role.disabled &&
                        role.name !== 'Admin' &&
                        role.name !== 'Business Owner' &&
                        role.name !== 'Employee' &&
                        role.name !== 'Contractor' &&
                        role.name !== 'Trainee'
                      "
                      (click)="openModal(false, role.id)"
                    >
                      <i class="ti ti-lock"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      *ngIf="
                        !role.disabled &&
                        role.name !== 'Admin' &&
                        role.name !== 'Business Owner' &&
                        role.name !== 'Employee' &&
                        role.name !== 'Contractor' &&
                        role.name !== 'Trainee'
                      "
                      (click)="openModal(true, role.id)"
                    >
                      <i class="ti ti-lock-open-2"></i>
                    </a> 
                    <a
                      href="javascript:void(0);"
                      *ngIf="
                        role.name !== 'Admin' &&
                        role.name !== 'Business Owner' &&
                        role.name !== 'Employee' &&
                        role.name !== 'Contractor' &&
                        role.name !== 'Trainee'
                      "
                      (click)="openDeleteModal(role.id)"
                      ><i class="ti ti-trash"></i
                    ></a> -->
                      <!-- <ng-container
                      *ngIf="
                        !role.isStandard &&
                        role.name !== 'Admin' &&
                        role.name !== 'Business Owner' &&
                        role.name !== 'Employee' &&
                        role.name !== 'Contractor' &&
                        role.name !== 'Trainee'
                      "
                    > -->
                      <ng-container
                        *ngIf="
                          role.name !== 'Admin' &&
                          role.name !== 'Business Owner' &&
                          role.name !== 'Employee' &&
                          role.name !== 'Contractor' &&
                          role.name !== 'Trainee'
                        "
                      >
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          *appHasPermission="{ role: ['delete'] }"
                          (click)="openDeleteModal(role.id)"
                        >
                          <i class="ti ti-trash"></i>
                        </a>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- pagination -->
    <!-- <div class="has-text-centered mt-3" *ngIf="roleList.length > 0">
        <app-pagination [currentPage]="currentPage" [pageSize]="pageLimit" [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"></app-pagination>
      </div> -->
    <ng-container *ngIf="roles$ | async as roles">
      <div class="d-flex align-items-center justify-content-between ms-2" *ngIf="roles.length > 0">
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalCount }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Add role -->
<ng-template #addBusinessModals let-modal>
  <!-- <div class="modal fade" id="add_users">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">{{ modalTitle }}</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <!-- <div
          [ngClass]="{
            'col-md-9': isAdmin(),
            'col-md-12': !isAdmin()
          }"
        > -->
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="role">Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="role"
              name="role"
              formControlName="name"
              [disabled]="isSystemRole"
            />
          </div>
        </div>

        <!-- <div class="col-md-3" *ngIf="isAdmin()">
          <div class="mb-3">
            <label class="form-label col-lg-12"
              >Is Standard?
              <div class="form-check form-check-inline form-check-md form-switch me-2">
                <label class="form-check-label mt-0">
                  <input
                    class="form-check-input me-2"
                    type="checkbox"
                    role="switch"
                    formControlName="isStandard"
                    (change)="toggleIsStandard()"
                  />
                  {{ isStandard ? 'Yes' : 'No' }}
                </label>
              </div>
            </label>
          </div>
        </div> -->

        <div class="col-md-12">
          <div class="mb-3">
            <label class="col-form-label" for="businessId"
              >Business Entity <span class="text-danger">*</span></label
            >
            <ng-select
              class="me-3 w-100"
              [items]="businesses$ | async"
              bindValue="id"
              placeholder="Select Business Entity"
              [searchable]="true"
              [clearable]="true"
              [searchFn]="customSearchFn"
              style="width: 200px"
              formControlName="businessIds"
              multiple
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.businessName | capitalize }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.businessName | capitalize }}
              </ng-template>
            </ng-select>
            <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('businessId') }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="">
            <div class="card-body p-0">
              <div class="table-container">
                <table class="table table-header">
                  <thead>
                    <tr>
                      <!-- <th>Module Permissions</th> -->
                      <!-- <th>Read</th>
                      <th>Create</th>
                      <th>Edit</th>
                      <th>Delete</th> -->
                      <th>Module Permissions</th>
                      <th>
                        <div class="form-check form-check-md">
                          <input
                            class="form-check-input me-2"
                            type="checkbox"
                            (change)="toggleAllColumn('view', getChecked($event))"
                            [checked]="isAllChecked('view')"
                          />
                          Read
                        </div>
                      </th>
                      <th>
                        <div class="form-check form-check-md">
                          <input
                            class="form-check-input me-2"
                            type="checkbox"
                            (change)="toggleAllColumn('add', getChecked($event))"
                            [checked]="isAllChecked('add')"
                          />
                          Create
                        </div>
                      </th>
                      <th>
                        <div class="form-check form-check-md">
                          <input
                            class="form-check-input me-2"
                            type="checkbox"
                            (change)="toggleAllColumn('edit', getChecked($event))"
                            [checked]="isAllChecked('edit')"
                          />
                          Edit
                        </div>
                      </th>
                      <th>
                        <div class="form-check form-check-md me-2">
                          <input
                            class="form-check-input me-2"
                            type="checkbox"
                            (change)="toggleAllColumn('delete', getChecked($event))"
                            [checked]="isAllChecked('delete')"
                          />
                          Delete
                        </div>
                      </th>
                    </tr>
                  </thead>
                </table>
                <div class="table-body-scroll">
                  <table class="table">
                    <!-- <thead class="thead-light">
                      <tr>
                        <th>Module Permissions</th>
                        <th>
                          <div class="form-check form-check-md">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              (change)="toggleAllColumn('view', getChecked($event))"
                              [checked]="isAllChecked('view')"
                            />
                            Read
                          </div>
                        </th>
                        <th>
                          <div class="form-check form-check-md">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              (change)="toggleAllColumn('add', getChecked($event))"
                              [checked]="isAllChecked('add')"
                            />
                            Create
                          </div>
                        </th>
                        <th>
                          <div class="form-check form-check-md">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              (change)="toggleAllColumn('edit', getChecked($event))"
                              [checked]="isAllChecked('edit')"
                            />
                            Edit
                          </div>
                        </th>
                        <th>
                          <div class="form-check form-check-md me-2">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              (change)="toggleAllColumn('delete', getChecked($event))"
                              [checked]="isAllChecked('delete')"
                            />
                            Delete
                          </div>
                        </th>
                      </tr>
                    </thead> -->
                    <tbody>
                      <tr *ngFor="let module of permissionModules">
                        <ng-container
                          *ngIf="
                            module.name !== 'user' &&
                            module.name !== 'dashboard' &&
                            module.name !== 'tasks' &&
                            module.name !== 'taxSlabs' &&
                            module.name !== 'taxRules' &&
                            module.name !== 'reports'
                          "
                        >
                          <td>
                            <h6 class="fs-14 fw-normal text-gray-9">
                              {{ module.name | formatModuleName }}
                            </h6>
                          </td>
                          <td>
                            <div class="form-check form-check-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [checked]="permissionsState[module.key]?.view"
                                (change)="togglePermission(module, 'view', getChecked($event))"
                              />
                            </div>
                          </td>
                          <td>
                            <div class="form-check form-check-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [checked]="permissionsState[module.key]?.add"
                                (change)="togglePermission(module, 'add', getChecked($event))"
                              />
                            </div>
                          </td>
                          <td>
                            <div class="form-check form-check-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [checked]="permissionsState[module.key]?.edit"
                                (change)="togglePermission(module, 'edit', getChecked($event))"
                              />
                            </div>
                          </td>
                          <td>
                            <div class="form-check form-check-md">
                              <input
                                class="form-check-input me-2"
                                type="checkbox"
                                [checked]="permissionsState[module.key]?.delete"
                                (change)="togglePermission(module, 'delete', getChecked($event))"
                              />
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" (click)="onSubmit()">Submit</button>
    </div>
  </form>
  <!-- </div>
      </div>
    </div> -->
</ng-template>
<!-- /Add role -->

<!-- view role -->
<ng-template #viewBusinessModals let-modal>
  <!-- <div class="modal fade" id="add_users">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">{{ modalTitle }}</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body pb-0">
    <div class="row">
      <!-- <div
        [ngClass]="{
          'col-md-9': isAdmin(),
          'col-md-12': !isAdmin()
        }"
      >
        <div class="mb-3">
          <label class="form-label" for="role">Title <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="role" name="role" [disabled]="isSystemRole" />
        </div>
      </div> -->

      <div class="col-md-12">
        <div class="card">
          <div class="card-body p-0">
            <div class="table-responsive table-container">
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th>Module Permissions</th>
                    <th>
                      <div class="form-check form-check-md">
                        <input class="form-check-input me-2" type="checkbox" disabled />
                        Read
                      </div>
                    </th>
                    <th>
                      <div class="form-check form-check-md">
                        <input class="form-check-input me-2" type="checkbox" disabled />
                        Create
                      </div>
                    </th>
                    <th>
                      <div class="form-check form-check-md">
                        <input class="form-check-input me-2" type="checkbox" disabled />
                        Edit
                      </div>
                    </th>
                    <th>
                      <div class="form-check form-check-md me-2">
                        <input
                          class="form-check-input me-2"
                          type="checkbox"
                          (change)="toggleAllColumn('delete', getChecked($event))"
                          disabled
                        />
                        Delete
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let module of permissionModules">
                    <ng-container
                      *ngIf="
                        module.name !== 'user' &&
                        module.name !== 'dashboard' &&
                        module.name !== 'tasks' &&
                        module.name !== 'taxSlabs' &&
                        module.name !== 'taxRules' &&
                        module.name !== 'reports'
                      "
                    >
                      <td>
                        <h6 class="fs-14 fw-normal text-gray-9">
                          {{ module.name | formatModuleName }}
                        </h6>
                      </td>
                      <td>
                        <div class="form-check form-check-md">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [checked]="permissionsState[module.key]?.view"
                            disabled
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-check-md">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [checked]="permissionsState[module.key]?.add"
                            disabled
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-check-md">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [checked]="permissionsState[module.key]?.edit"
                            disabled
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check form-check-md">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [checked]="permissionsState[module.key]?.delete"
                            disabled
                          />
                        </div>
                      </td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- </div>
      </div>
    </div> -->
</ng-template>
<!-- /view role -->
